import {
  Link,
  Outlet,
  createRootRoute,
  createRoute,
  createRouter,
} from '@tanstack/react-router'
import { useAuth } from './auth'
import { ThemeToggle } from './components/ThemeToggle'
import { AccountsPage } from './pages/AccountsPage'
import { DashboardPage } from './pages/DashboardPage'
import { HoldingsPage } from './pages/HoldingsPage'
import { ImportPage } from './pages/ImportPage'
import { TransactionsPage } from './pages/TransactionsPage'

function Shell() {
  const { user, signOut } = useAuth()

  return (
    <div className="shell">
      <header className="topbar">
        <span className="brand">
          <span className="brand-mark" aria-hidden="true" />
          Green Candle
        </span>

        <nav className="nav">
          <Link to="/" activeProps={{ className: 'active' }} activeOptions={{ exact: true }}>
            Dashboard
          </Link>
          <Link to="/holdings" activeProps={{ className: 'active' }}>
            Holdings
          </Link>
          <Link to="/transactions" activeProps={{ className: 'active' }}>
            Transactions
          </Link>
          <Link to="/accounts" activeProps={{ className: 'active' }}>
            Accounts
          </Link>
          <Link to="/import" activeProps={{ className: 'active' }}>
            Import
          </Link>
        </nav>

        <div className="topbar-end">
          <span className="muted">{user?.username}</span>
          <ThemeToggle />
          <button type="button" onClick={() => void signOut()}>
            Sign out
          </button>
        </div>
      </header>

      <main className="page">
        <Outlet />
      </main>
    </div>
  )
}

const rootRoute = createRootRoute({ component: Shell })

const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: DashboardPage,
})

const accountsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/accounts',
  component: AccountsPage,
})

const holdingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/holdings',
  component: HoldingsPage,
})

const transactionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/transactions',
  component: TransactionsPage,
})

const importRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/import',
  component: ImportPage,
})

const routeTree = rootRoute.addChildren([dashboardRoute, holdingsRoute, transactionsRoute, accountsRoute, importRoute])

export const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
